module.exports = __webpack_public_path__ + "static/media/nyx.54634a7f.jpeg";